module.exports = __webpack_public_path__ + "hinted-OpenSans-Light.7bf931ca572048f5351d.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSans-Light.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSans-Light.woff
// module chunks = 1